/**
 * Entity — a game object with attachable components.
 *
 * Wraps a Phaser game object (sprite, rectangle, etc.) and allows
 * components to be added for composable behavior.
 */

import { Component } from "./Component";

export class Entity {
  public sprite: any;
  private components: Map<string, Component> = new Map();
  public active: boolean = true;

  constructor(sprite: any) {
    this.sprite = sprite;
  }

  add(component: Component): this {
    this.components.set(component.key, component);
    if (component.init) {
      component.init(this);
    }
    return this;
  }

  get<T extends Component>(key: string): T | undefined {
    return this.components.get(key) as T | undefined;
  }

  has(key: string): boolean {
    return this.components.has(key);
  }

  remove(key: string): void {
    const c = this.components.get(key);
    if (c) {
      if (c.destroy) c.destroy();
      this.components.delete(key);
    }
  }

  update(time: number, delta: number): void {
    if (!this.active) return;
    this.components.forEach((c) => {
      if (c.update) c.update(this, time, delta);
    });
  }

  destroy(): void {
    this.components.forEach((c) => {
      if (c.destroy) c.destroy();
    });
    this.components.clear();
    if (this.sprite && this.sprite.destroy) {
      this.sprite.destroy();
    }
  }
}
